// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dzSq","toggleWrap":"styles_toggleWrap__1oAAL","content":"styles_content__2AzZ3","selectAreaCode":"styles_selectAreaCode__5G4eE"};